import { render, staticRenderFns } from "./TheoDoiTinhTrangPhong.vue?vue&type=template&id=c9bc26a4&scoped=true&"
import script from "./TheoDoiTinhTrangPhong.vue?vue&type=script&lang=js&"
export * from "./TheoDoiTinhTrangPhong.vue?vue&type=script&lang=js&"
import style0 from "./TheoDoiTinhTrangPhong.vue?vue&type=style&index=0&id=c9bc26a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bc26a4",
  null
  
)

export default component.exports